export enum ExtensionsEnum {
  IMAGE = '.png,.jpg,.jpeg,.webp',
  PDF = '.pdf',
}
